<template>
  <div class="auth-page">
    <div class="auth-page__wrapper">
      <div class="auth-block">
        <div class="auth-block__logo">
          <img
            class="auth-block__logo__image"
            :src="require(`@/assets/images/logo_${$config.styleName}.svg`)"
            width="121"
            height="93"
          >
          <span class="auth-block__logo__title">{{ $t('common.portal') }}</span>
        </div>
        <slot />
        <locale-switch class="mx-auto" />
      </div>
      <privacy />
    </div>
  </div>
</template>

<script>
import Privacy from '@/components/auth/Privacy';
import LocaleSwitch from '@/components/common/LocaleSwitch';

export default {
  name: 'AuthWrapper',
  components: {
    Privacy,
    LocaleSwitch,
  },
};
</script>
